import { createAsyncThunk } from '@reduxjs/toolkit';
import { Wishlist } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindUserWishlist } from './interface';

export const findUserWishlist = createAsyncThunk(
  'userWishlist/findUserWishlist',
  async (values: FindUserWishlist, { rejectWithValue }) => {
    try {
      const response = await Wishlist.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
